export default {
  meta: {
    title: '踩点报告PDF'
  }
};
